import request from "@/util/http";
/**
 * 详情
 */
export function detail(params) {
	return request({
		url: '/goods/shop/goods/detail',
		method: 'get',
		params:params,
	})
}


/**
 * 对比栏
 */
export function compare_bar(query) {
	return request({
		url: '/goods/shop/goods/compare_bar',
		method: 'get',
		params: query,
	})
}



/**
 * 添加对比
 */
export function add_compare(params) {
	return request({
		url: '/goods/shop/goods/add_compare',
		method: 'get',
		params: params,
	})
}



/**
 * 浏览记录
 */
export function history(params) {
	return request({
		url: '/goods/shop/goods/history',
		method: 'get',
		params: params,
	})
}


/**
 * 列表
 */
export function list_by_category(params) {
	return request({
		url: '/goods/shop/goods/list/' + id,
		method: 'get',
		params: params,
	})
}

/**
 * 店铺商品_列表
 */
export function store_list(params) {
	return request({
		url: '/goods/shop/goods/store_list',
		method: 'GET',
		params: params,
	})
}

/**
 * 列表
 */
export function list(data,params) {
	return request({
		url: '/goods/shop/goods/list',
		method: 'POST',
		data:data,
		params: params,
	})
}

/**
 * 列表
 */
export function list_json(params) {
	return request({
		url: '/goods/shop/goods/list_json',
		method: 'get',
		params: params,
	})
}

/**
 * 搜索
 */
export function search(params) {
	return request({
		url: '/goods/shop/goods/search',
		method: 'get',
		params: params,
	})
}



/**
 * 搜索
 */
export function search_json(params) {
	return request({
		url: '/goods/shop/goods/search_json',
		method: 'get',
		params: params,
	})
}



/**
 * 对比
 */
export function compare(params) {
	return request({
		url: '/goods/shop/goods/compare',
		method: 'get',
		params: params,
	})
}



/**
 * 点击数
 */
export function hits(params) {
	return request({
		url: '/goods/shop/goods/hits/' + id,
		method: 'get',
		params: params,
	})
}

/**
 * 首页楼层
 */
export function index(params) {
	return request({
		url: '/goods/shop/goods/index',
		method: 'get',
		params: params,
	})
}

/**
 * 商品 推荐
 */
export function recommend(params) {
	return request({
		url: '/goods/shop/goods/recommend',
		method: 'get',
		params: params,
	})
}


/**
 * 列表
 */
export function exchange_list(params) {
	return request({
		url: '/goods/shop/goods/exchange_list',
		method: 'get',
		params: params,
	})
}






// module.exports = {
// 	detail,
// 	compare_bar,
// 	add_compare,
// 	history,
// 	list_by_category,
// 	store_list,
// 	list,
// 	list_json,
// 	search,
// 	search_json,
// 	compare,
// 	hits,
// 	index,
// 	recommend,
// 	exchange_list
// }
